
import XHeader from '@/components/XHeader/XHeader'
import moment from 'moment'
import WechatShare from '@/components/WechatShare/WechatShare'
import Previewer from '@/components/XPreview/UPreview'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
  directives: {
    TransferDom
  },
  props: [

  ],
  data() {
    return {
      currentIndex: 0,
      scrollDisabled: false,
      interactionList: [],
      liveId: 0,
      pageIndex: 1,
      pageSize: 10,
      loadMessage: '努力加载中 ...',
      previewerList: [],
      options: {
        bgOpacity: 0.9,
        loop: false,
        clickToCloseNonZoomable: false,
        tapToClose: false,
        isClickableElement: function(el) {
          // el.stopPropagation();
          if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1) {
            return true
          } else {
            return false;
          }
        },
        errorMsg: '<div class="pswp__error-msg">哎呀，图片加载不出来了...</div>',
      }
    }
  },
  computed: {
    list() {
      return this.$store.state.live.currentUserInteractionList.Result
    },
    interactionCount() {
      return this.$store.state.live.currentUserInteractionList.Total
    },
    params() {
      return this.$route.params
    }
  },
  methods: {
    direct(id) {
      this.$router.push({
        name: 'userInteractionDetail',
        params: { liveId: this.params.liveId, interactionId: id }
      })
    },
    refresh() {
      this.$vux.loading.show({
        text: '正在加载...'
      })
      this.interactionList = []
      this.pageIndex = 1
      this.loadMessage = '努力加载中...'
      this.fetchInteraction()
    },
    show(url, index, id) {
      let new_url = encodeURIComponent(url)
      let width = document.getElementById(index).width
      let height = document.getElementById(index).height
      // 清空数组，并push新元素进去
      this.previewerList = []
      let item = {
        'w': width * 3,
        'h': height * 3,
        'src': url
      }
      this.currentIndex = index
      this.previewerList.push(item)
      this.$refs.previewer.show(item, id)
    },
    dateFormat(time) {
      return moment(time).format('MM月DD日 HH:mm')
    },
    fetchInteraction() {
      // 获取当前对应直播的互动信息
      this.$store.dispatch({
        type: 'getUserInteractionList',
        liveId: this.liveId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        userId: JSON.parse(window.localStorage.user).Id
      }).then(() => {
        this.list.map(item => {
          this.interactionList.push(item)
        })
        // 判断dom是否渲染完毕
        this.$nextTick(() => {
          this.scrollDisabled = false
          this.$vux.loading.hide()
        })
      })
    },
    loadMore() {
      // 判断页面是否滚动到底部
      if (!this.scrollDisabled && document.documentElement.offsetHeight != 0 && document.documentElement.clientHeight + window.scrollY >= document.documentElement.offsetHeight) {
        // 禁用滚动
        this.scrollDisabled = true
        // 加载数据
        if (this.interactionList.length < this.interactionCount) {
          this.pageIndex++
          this.fetchInteraction()
        } else {
          this.loadMessage = ''
        }
      }
    },
  },
  watch: {
    $route: 'refresh'
  },
  components: {
    XHeader,
    Previewer,
    WechatShare
  },
  mounted() {
    this.$vux.loading.show({
      text: '正在加载...'
    })
    // 监听页面滚动事件
    window.addEventListener('scroll', this.loadMore, false)
    // 获取路由ID
    this.liveId = this.$route.params.liveId

    // 分页加载此次活动对应的列表页面
    // 每页显示10条数据
    this.fetchInteraction()
  }
}



// WEBPACK FOOTER //
// ./src/pages/user/Index.vue